module.exports = __webpack_public_path__ + "img/service_img1.eae284c1.png";